export const UPDATE_IMAGES_TO_UPLOAD = 'UPDATE_IMAGES_TO_UPLOAD';
export const UPDATING_FILE_PERCENTAGE = 'UPDATING_FILE_PERCENTAGE';
export const UPDATE_UPLOAD_PERCENTAGE = 'UPDATE_UPLOAD_PERCENTAGE';
export const SHOW_PROGESS_BAR = 'SHOW_PROGESS_BAR';
export const DELETE_BILL = 'DELETE_BILL';
export const HIDE_PROGESS_BAR = 'HIDE_PROGESS_BAR';
export const RESET_BILL_UPLOAD = 'RESET_BILL_UPLOAD';